import { fetchWrapper } from '../Helpers';

const baseUrl = `${process.env.REACT_APP_API_URL}/recharge/payment`;

export const rechargeService = {
  rechargeToken
};
function rechargeToken(params) {
  return fetchWrapper.post(baseUrl, params);
}